var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.preview
  }, [_c('base-icon', {
    directives: [{
      name: "p-t",
      rawName: "v-p-t",
      value: 4,
      expression: "4"
    }, {
      name: "color",
      rawName: "v-color:black-2",
      arg: "black-2"
    }],
    attrs: {
      "name": "shopping_percent"
    }
  })], 1), _c('div', {
    class: _vm.$style.content
  }, [_c('div', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 10,
      expression: "10"
    }],
    class: _vm.$style.title,
    domProps: {
      "textContent": _vm._s(_vm.$t('commission.of.service'))
    }
  }), _c('div', {
    class: _vm.$style.commission,
    domProps: {
      "textContent": _vm._s(_vm.displayAmount)
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }